import axios from 'axios'
import { contactSubmissionAccepted } from '../utils/contactSubmission'
export default {
  namespaced: true,

  state: {

  },

  getters:{

  },

  mutations: {

  },
  actions: {
    async getContent({commit},payload){
        try {
            return await axios({
                method: 'get',
                url: payload.url,
                data: payload.data
            });
        } catch (e) {
            return e.response
        }
    },
    async submitContactUsForm({commit},payload){
        return axios({
            url: payload.url,
            method: 'POST',
            data: payload
        }).then((response) => {
            return contactSubmissionAccepted(response) ? {status:true} : {status:false}
        }) .catch(error => {
            return {status:false,error:error}
        });
    },
  },
}